export default "dist/images/body.png"